"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalCloseButton = void 0;
const react_1 = __importDefault(require("react"));
const io5_1 = require("react-icons/io5");
const HackerIconButton_1 = require("./HackerIconButton");
const ModalCloseButton = ({ onClose }) => {
    return (react_1.default.createElement(HackerIconButton_1.HackerIconButton, { icon: react_1.default.createElement(io5_1.IoCloseSharp, { size: 18 }), position: "absolute", top: "0", right: "0", zIndex: 3, onClick: onClose, variant: "unstyled", justifyContent: "center", alignItems: "center", padding: "7px", h: "32px", w: "32px", minW: "32px", maxW: "32px" }));
};
exports.ModalCloseButton = ModalCloseButton;
//# sourceMappingURL=ModalCloseButton.js.map